"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trueDocs = void 0;
var trueDocs = exports.trueDocs = {
  name: 'true',
  category: 'Constants',
  syntax: ['true'],
  description: 'Boolean value true',
  examples: ['true'],
  seealso: ['false']
};